import { createUseStyles } from 'react-jss';

import { FontWeight, ITheme, mediaQuery } from '../../../styles';

const CONTAINER_PADDING = 40;

const useStyles = createUseStyles<
  string,
  {
    descriptionFontSmall: boolean;
    titleCentered: boolean;
    mobileImageFirst: boolean;
  }
>(
  ({ breakpoints }: ITheme) => ({
    root: {
      margin: [0, 35, 94, 35],

      [mediaQuery(breakpoints.tablet)]: {
        margin: [32, 24],
      },
    },
    content: {
      color: '#5F5F5F',
      display: 'flex',
      gap: 42,
      justifyContent: 'space-between',
      alignItems: 'center',
      maxWidth: 1260,
      padding: [0, CONTAINER_PADDING],
      margin: 'auto',

      [mediaQuery(breakpoints.tablet)]: {
        alignItems: 'center',
        flexDirection: ({ mobileImageFirst }) => {
          return mobileImageFirst ? 'column' : 'column-reverse';
        },
        padding: [0, 0, 0, 0],
        marginBottom: 0,
      },
    },
    inverse: {
      flexDirection: 'row-reverse',

      [mediaQuery(breakpoints.tablet)]: {
        flexDirection: 'column-reverse',
      },
    },
    imgContainer: {
      [mediaQuery(breakpoints.tablet)]: {
        textAlign: 'center',

        '& > span': {
          width: 'auto !important',
        },
      },
    },
    img: {
      maxWidth: '100%',
    },
    textContainer: {
      width: 'min(100%, 557px)',

      [mediaQuery(breakpoints.tablet)]: {
        width: '100%',
      },
    },
    heading: {
      color: 'var(--x-accent-2-1)',
      fontSize: ({ titleCentered }) => (titleCentered ? 60 : 42),
      fontWeight: 500,
      lineHeight: ({ titleCentered }) => (titleCentered ? '72px' : '52px'),
      marginBottom: ({ titleCentered }) => (titleCentered ? 30 : 24),

      textAlign: ({ titleCentered }) => (titleCentered ? 'center' : 'left'),
      maxWidth: ({ titleCentered }) => (titleCentered ? 1000 : 'auto'),
      margin: 'auto',

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: () => 30,
        lineHeight: () => '42px',
        textAlign: () => 'left',
        marginBottom: () => 24,
      },
    },
    smallTitle: {
      fontWeight: 500,
      fontSize: 20,
      lineHeight: '28px',
      marginBlockEnd: 4,
    },
    paragraph: {
      fontSize: ({ descriptionFontSmall }) => (descriptionFontSmall ? '16px' : '20px'),
      lineHeight: ({ descriptionFontSmall }) => (descriptionFontSmall ? '24px' : '28px'),
      fontWeight: FontWeight.Medium,

      '& + div': {
        marginTop: '24px',
      },
    },
  }),
  {
    name: 'ImageWithTextSection',
  },
);

export default useStyles;
